import { widget } from "@foretagsplatsen/widgetjs";
import CompanyBalanceChartWidget from "../shared/CompanyBalanceChartWidget.js";
import companyLegendWidget from "./companyLegendWidget.js";
import spinner from "../../core/elements/spinner/spinner.js";

/**
 * Widget for the company charts.
 * Creates one company chart for the start of the period (opening), one for the end (closing) and the legend.
 */
function companyWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const that = widget(spec, my);

	my.companyLegend = companyLegendWidget({
		dataHelpName: "company-balance-legend",
	});

	that.show = function (companyTransitionBalance) {
		const openingBalance = companyTransitionBalance.openingBalance;
		const closingBalance = companyTransitionBalance.closingBalance;

		my.companyBalanceChart = new CompanyBalanceChartWidget({
			dates: [openingBalance.date, closingBalance.date],
			currentAssets: [
				openingBalance.currentAssets,
				closingBalance.currentAssets,
			],
			fixedAssets: [
				openingBalance.fixedAssets,
				closingBalance.fixedAssets,
			],
			totalLiability: [
				openingBalance.totalLiability,
				closingBalance.totalLiability,
			],
			ownersPart: [openingBalance.ownersPart, closingBalance.ownersPart],
		});

		my.companyLegend.setValues(companyTransitionBalance);
		this.update();
	};

	that.renderContentOn = function (html) {
		if (!my.companyBalanceChart) {
			spinner({ renderOn: html });

			return;
		}

		html.div({ class: "company-chart" }, my.companyBalanceChart);
		html.render(my.companyLegend);
	};

	return that;
}

export default companyWidget;
